import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("gloss.token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const unwrap = (res) => res?.data?.data ?? res?.data;
